import { isWithinInterval } from 'date-fns'
import { getDateWithoutTZ } from './formatDateTime'

export const isCurrentlyOn = (
  startDate: string | null,
  endDate: string | null,
): boolean => {
  let isCurrentlyOn = false
  if (startDate && endDate) {
    const time = new Date()
    const startTime = getDateWithoutTZ(startDate)
    const endTime = getDateWithoutTZ(endDate)
    if (!(startTime <= endTime)) return false
    isCurrentlyOn = isWithinInterval(time, { start: startTime, end: endTime })
  }
  return isCurrentlyOn
}
